<template>
  <div class="box">
    <!--导航栏 start-->
    <van-nav-bar left-text="返回" fixed title="添加" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <!--导航栏 end-->
    <van-form style="background-color: white" @submit="onSubmit">
      <van-field
        name="payCode"
        v-model="form.payCode"
        label="收款码ID"
        placeholder="请输入收款码ID"
        clearable
        clickable
      />
      <!-- 选择通道 -->
      <van-field
        readonly
        clickable
        required
        name="current_gangway"
        :rules="[{ required: true, message: '通道必选' }]"
        :value="current_gangway_text"
        label="选择通道"
        placeholder="点击选择通道"
        @click="current_gangway_show_picker = true"
      />
      <van-popup v-model="current_gangway_show_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="current_gangway_columns"
          @confirm="onSettlementAccountTypeConfirm"
          @cancel="current_gangway_show_picker = false"
        />
      </van-popup>
      <!--  -->
   

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">下一步</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
// import { Toast, Dialog, Notify } from "vant";
import { easypayArea } from "@/assets/json/easypay_area";
// import LeshuazfMcc from "@/assets/json/leshuazf_mcc";
// import VueCookie from "vue-cookies";
// import wx from 'weixin-js-sdk'
// import phone_upload_img from "@/assets/images/phone_upload.png";
// import Config from "@/config";
let wx =
  process.env.NODE_ENV == "develepment"
    ? require("weixin-js-sdk")
    : window["wx"];
export default {
  name: "merchant_add",
  data() {
    return {
      current_gangway_text: "",
      current_gangway_show_picker: false,
      current_gangway_columns: [
        {
          text: "中付",
          value: "zhongfu",
        },
        {
          text: "易生",
          value: "easypay",
        },
        {
          text: "其他",
          value: "other",
        },
      ],
      settlement_period_text: "",
      settlement_period_show_picker: false,
      settlement_period_columns: [
        // {
        //   text: "T0",
        //   value: "T0",
        // },
        {
          text: "T1",
          value: "T1",
        },
        {
          text: "D1",
          value: "D1",
        },
        {
          text: "D0",
          value: "D0",
        },
      ],
      show_address_picker: false,
      areaCode: "",
      options: easypayArea,
      form: {
        payCode: "", //支付码
        current_gangway: "", //选择通道
        // settlement_period: "D1", //结算类型
        // mer_area: "",
        // mer_area_name: "",
      },
      show: false,
      fieldValue: "",
      cascaderValue: "",
    };
  },
  mounted() {
    this.form.payCode = this.$route.query.pay_code;
    console.log("easypay_area", this.easypay_area);
    // if (localStorage.getItem("form")) {
    //   console.log(JSON.parse(localStorage.getItem("form")));
    //   var form = JSON.parse(localStorage.getItem("form"));
    //   this.form.current_gangway = form.current_gangway;
    //   if (form.current_gangway == "easypay") {
    //     this.current_gangway_text = "易生";
    //   } else {
    //     this.current_gangway_text = "其他";
    //   }
    //   this.fieldValue = form.mer_area_name;
    //   this.settlement_period_text = form.settlement_period;
    // }
    // var province_list = {};
    // var city_list = {};
    // this.easypay_area.forEach((element) => {
    //   // console.log(element.value)
    //   // var val = element.value
    //   province_list = {
    //     ...province_list,
    //     [element.value]: element.label,
    //   };
    //   element.children.forEach((res) => {
    //     // console.log(res);
    //     city_list = {
    //       ...city_list,
    //       [res.value]: res.label,
    //     };
    //   });
    // });
    // console.log(province_list);
    // console.log(city_list);
  },
  methods: {
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/SalesmanHome");
    },
    onSubmit(values) {
      console.log(this.form);
      //   console.log("submit", values);
      if (this.form.current_gangway == "other") {
        this.$router.push({
          path: "/Merchant/addOther",
          query: { form: JSON.stringify(this.form) },
        });
      } else if(this.form.current_gangway == "easypay"){
        this.$router.push({
          path: "/Merchant/addEasypay",
          query: { form: JSON.stringify(this.form) },
        });
      }else if(this.form.current_gangway == "zhongfu"){
        this.$router.push({
          path: "/Merchant/zhongfu",
          query: { form: JSON.stringify(this.form) },
        });
      }
      //Merchant/zhongfu
    },

    // 选择通道
    onSettlementAccountTypeConfirm(val) {
      console.log(val);
      this.current_gangway_text = val.text;
      this.form.current_gangway = val.value;
      this.current_gangway_show_picker = false;
    },
   
    onAddressConfirm() {},
  },
};
</script>
<style scoped>
.box {
  padding-top: 46px;
}
</style>